"use client"

import type { ReactNode } from "react"
import { Link } from "react-router-dom"
import type { MembersHomePerson } from "@ibada/shared-types/overview"

import { PersonContactButtons } from "@/features/dashboard/home-d4/components/person-contact-buttons"
import { fullName } from "@/features/dashboard/home-d4/lib/home-format"
import { MemberAvatar } from "@/features/members/components/members-views"

/**
 * One person in a board list, the D4 row: avatar, name linking to the profile, a muted detail line, then the
 * actions (an optional primary action, call and WhatsApp).
 */
export function BoardPersonRow({
  person,
  detail,
  profileHref,
  action,
  showCall = true,
  testId,
}: {
  person: MembersHomePerson
  detail: string
  /** Null where no member profile page exists (the parish): the name is then plain text. */
  profileHref: string | null
  action?: ReactNode
  showCall?: boolean
  testId?: string
}) {
  const name = fullName(person.firstName, person.lastName)
  return (
    <li data-testid={testId} className='flex items-center gap-2.5'>
      <MemberAvatar member={{ name, avatarUrl: person.avatarUrl }} className='size-[30px] text-[11px]' />
      <span className='flex min-w-0 flex-1 flex-col'>
        {profileHref ? (
          <Link to={profileHref} className='truncate text-[13px] font-bold hover:underline'>
            {name}
          </Link>
        ) : (
          <span className='truncate text-[13px] font-bold'>{name}</span>
        )}
        <span className='truncate text-[11.5px] text-muted-foreground'>{detail}</span>
      </span>
      {action}
      <PersonContactButtons name={name} phone={person.phone} showCall={showCall} />
    </li>
  )
}
